export default __webpack_public_path__ + "static/hom-performance-17669f17ffe958ee28e5a4610f283698.svg";